<script>
	export let cols = null;
	export let scale = "md";
	export let style = null;

	let className = "";
	export { className as class };

	$: colsClass = cols ? `-${cols}` : "";
	$: scaleClass = colsClass && scale ? `-${scale}` : "";

</script>

<div class="col{scaleClass}{colsClass}{!className ? '' : ' ' + className}" {style}>
	<slot></slot>
</div>

<style>
	div {
		margin-top: 20px;
	}

	@media (min-width: 768px) {
		div {
			margin-top: 0;
		}
	}
</style>
